// {{WORKTREE_ROOT}}/picosponsorconsole/packages/design/src/testids.ts
// PLAN2 WP09 — the design package's test ids (L-48: a contract; append-only).
const parts = <P extends string>(component: string, ...names: P[]) =>
  Object.fromEntries(names.map((n) => [n.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase()), `design.${component}.${n}`])) as Record<string, string>;

export const DESIGN_TESTIDS = {
  agentMark: parts("agent-mark", "root"),
  wordmark: parts("wordmark", "root"),
  brandmark: parts("brandmark", "root"), // PLAN11 WP11-07
  button: parts("button", "root", "reason", "dots"),
  iconButton: parts("icon-button", "root"),
  textField: parts("text-field", "input", "error"),
  textArea: parts("text-area", "input", "error"),
  select: parts("select", "input"),
  combobox: parts("combobox", "input"),
  checkbox: parts("checkbox", "input"),
  radio: parts("radio", "group", "input"),
  toggle: parts("toggle", "track", "knob"),
  segmentedControl: parts("segmented-control", "root", "option"),
  filterChip: parts("filter-chip", "root"),
  badge: parts("badge", "root"),
  tabs: parts("tabs", "root", "tab"),
  stepper: parts("stepper", "root", "decrease", "increase", "input"),
  dialog: parts("dialog", "root", "close"),
  popover: parts("popover", "trigger", "panel"),
  menu: parts("menu", "trigger", "list", "item"),
  toast: parts("toast", "region", "item", "close"),
  tooltip: parts("tooltip", "bubble"),
  spinner: parts("spinner", "root"),
  loadingDots: parts("loading-dots", "root"),
  skeleton: parts("skeleton", "group", "block"),
  pageSkeleton: parts("page-skeleton", "root"),
  progressHairline: parts("progress-hairline", "track", "fill"),
  meter: parts("meter", "root", "bar"),
  avatar: parts("avatar", "root"),
  codeInput: parts("code-input", "root", "digit", "single", "error"),
  pageToolbar: parts("page-toolbar", "root"),
  splitPane: parts("split-pane", "root", "aside"),
  panelSection: parts("panel-section", "root"),
  paperSheet: parts("paper-sheet", "root"),
  eyebrow: parts("eyebrow", "root"),
  keyValueRow: parts("key-value-row", "root"),
  searchPill: parts("search-pill", "root", "input"),
  iconTile: parts("icon-tile", "root"),
  emptyState: parts("empty-state", "root", "action"),
  loadFailed: parts("load-failed", "root", "retry", "home", "request"),
  lockedState: parts("locked-state", "root", "plans"),
  dataTable: parts("data-table", "root", "table", "header", "row"),
  gradeChip: parts("grade-chip", "root"),
  gradeText: parts("grade-text", "root"),
  gradeDots: parts("grade-dots", "root", "dot", "summary"),
  gradeLegend: parts("grade-legend", "root"),
  obligationRow: parts("obligation-row", "root", "promise", "status", "confirm", "note"),
  deliverableCard: parts("deliverable-card", "root", "title", "due"),
  proofCard: parts("proof-card", "root", "thumb", "meta"),
  flagCard: parts("flag-card", "root", "title", "clauses", "primary", "dismiss"),
  proposalCard: parts("proposal-card", "root", "title", "body", "accept", "dismiss"),
  agentByline: parts("agent-byline", "root"),
  whyLink: parts("why-link", "root"),
  dealMapCard: parts("deal-map-card", "root", "name", "stats", "stat-kept", "stat-due", "stat-at-risk", "stat-missed", "coverage-track", "meta"),
  alertCard: parts("alert-card", "root", "severity", "what", "primary", "snooze", "open"), // ── WP21 ── open
  roomSummary: parts("room-summary", "root", "cell", "number", "day"),
  directionTag: parts("direction-tag", "root"),
  codenameBadge: parts("codename-badge", "root"),
  regionBadge: parts("region-badge", "root"),
  costPreview: parts("cost-preview", "root"),
  termsToggle: parts("terms-toggle", "root", "switch"),
  captureTile: parts("capture-tile", "root", "shutter", "not-this-one", "status"),
  migrationLedgerRow: parts("migration-ledger-row", "root", "confirm", "fix", "skip"),
  candidateCard: parts("candidate-card", "root", "basis", "accept", "park", "reject"),
  planRegion: parts("plan-region", "layer", "region"),
  findingCard: parts("finding-card", "root", "approve", "dismiss", "ask-again"),
  planCard: parts("plan-card", "root", "price", "cta"),
  documentFrame: parts("document-frame", "sheet", "title", "linked-number"),
  packageTray: parts("package-tray", "root", "item", "remove", "total"),
  clauseQuote: parts("clause-quote", "root"),
  chainSentence: parts("chain-sentence", "root"),
  stageStrip: parts("stage-strip", "root", "stage"),
} as const;

export const DESIGN_TESTID_LIST: readonly string[] = Object.values(DESIGN_TESTIDS).flatMap((p) => Object.values(p));
